import React, { useState } from "react";
import { DashboardIcon, ArticleIcon, UserIcon, LogoutIcon } from "./AdminIcons";

const Sidebar = ({ user, currentPage, setCurrentPage, onLogout }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const navItems = [
    { key: "dashboard", label: "Dashboard", icon: <DashboardIcon /> },
    { key: "articles", label: "Articles", icon: <ArticleIcon /> },
    { key: "users", label: "Users", icon: <UserIcon /> },
  ];

  return (
    <>
      {/* Desktop Sidebar */}
      <aside className="hidden md:flex w-64 bg-gray-800 text-white flex-col flex-shrink-0">
        <div className="h-20 flex items-center justify-center border-b border-gray-700 px-4">
          <img src="./logo.jpg" alt="Logo" className="w-40 h-16 object-contain p-0.5" />
        </div>
        <nav className="flex-grow">
          <ul>
            {navItems.map((item) => (
              <li key={item.key}>
                <a
                  href="#"
                  onClick={(e) => { e.preventDefault(); setCurrentPage(item.key); }}
                  className={`flex items-center px-4 py-3 hover:bg-gray-700 transition-colors duration-200 ${currentPage === item.key ? "bg-red-700" : ""} text-white`}
                >
                  {item.icon}
                  {item.label}
                </a>
              </li>
            ))}
          </ul>
        </nav>
        <div className="border-t border-gray-700 p-4">
          <p className="text-sm text-gray-400">Logged in as:</p>
          <p className="font-semibold break-words">{user.username}</p>
          <p className="text-xs bg-yellow-500 text-gray-900 font-bold inline-block px-2 py-0.5 rounded-full mt-1 break-all">{user.email}</p>
          <button onClick={() => onLogout()} className="w-full mt-4 flex items-center justify-center text-sm bg-red-700 hover:bg-red-800 text-white font-bold py-2 px-4 rounded-lg focus:outline-none focus:shadow-outline transition-colors duration-300">
            <LogoutIcon />
            Logout
          </button>
        </div>
      </aside>

      {/* Mobile Header with Hamburger */}
      <div className="md:hidden flex items-center justify-between bg-gray-800 text-white px-4 py-3 border-b border-gray-700 sticky top-0 z-20">
        <div className="flex items-center">
          <img src="./logo.jpg" alt="Logo" className="w-28 h-10 object-contain" />
          <span className="ml-2 font-bold text-yellow-500 text-lg">ADMIN</span>
        </div>
        <button className="p-2 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white rounded" onClick={() => setMenuOpen(!menuOpen)} aria-label="Open menu">
          <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={menuOpen ? "M6 18L18 6M6 6l12 12" : "M4 6h16M4 12h16M4 18h16"} />
          </svg>
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden absolute top-16 left-0 w-full bg-gray-900 z-50 shadow-lg">
          <nav>
            <ul>
              {navItems.map((item) => (
                <li key={item.key}>
                  <a
                    href="#"
                    onClick={(e) => { e.preventDefault(); setCurrentPage(item.key); setMenuOpen(false); }}
                    className={`flex items-center px-6 py-4 border-b border-gray-800 hover:bg-gray-700 transition-colors duration-200 ${currentPage === item.key ? "bg-red-700" : ""} text-white`}
                  >
                    {item.icon}
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>
          <div className="p-4 border-t border-gray-800">
            <p className="text-sm text-gray-400">Logged in as:</p>
            <p className="font-semibold break-words">{user.username}</p>
            <p className="text-xs bg-yellow-500 text-gray-900 font-bold inline-block px-2 py-0.5 rounded-full mt-1 break-all">{user.email}</p>
            <button onClick={() => onLogout()} className="w-full mt-4 flex items-center justify-center text-sm bg-red-700 hover:bg-red-800 text-white font-bold py-2 px-4 rounded-lg focus:outline-none focus:shadow-outline transition-colors duration-300">
              <LogoutIcon />
              Logout
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default Sidebar;
